import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  TextField,
} from "@mui/material";
import { useEffect, useState } from "react";
import * as services from "../../services/saleng";
import toast from "react-hot-toast";

const GroupFormDialog = ({ open, onClose, onSuccess, initialData }) => {
  const isEdit = Boolean(initialData);
  const [name, setName] = useState("");
  const [detail, setDetail] = useState("");

  useEffect(() => {
    if (!initialData) return;
    setName(initialData.name);
    setDetail(initialData.detail);
  }, [initialData]);

  const handleConfirm = async () => {
    const nameTrimmed = name.trim();
    const detailTrimmed = detail.trim();

    const payload = {
      name: nameTrimmed,
      detail: detailTrimmed,
      branchId: 1,
    };

    try {
      if (isEdit) {
        await services.editGroup(payload, initialData.id);
        toast.success("แก้ไขกลุ่มลูกค้าเรียบร้อย");
      } else {
        await services.createGroup(payload);
        toast.success("เพิ่มกลุ่มลูกค้าเรียบร้อย");
      }

      clearForm();
      onSuccess();
      onClose();
    } catch (err) {
      const errorMessage =
        err.response?.data || err.message || "เกิดข้อผิดพลาด";

      toast.error(errorMessage);
      console.error(err);
    }
  };

  const clearForm = async () => {
    setName("");
    setDetail("");
  };

  return (
    <Dialog
      open={open}
      onClose={() => {
        clearForm();
        onClose();
      }}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>
        {isEdit ? "แก้ไขกลุ่มลูกค้า" : "เพิ่มกลุ่มลูกค้า"}
      </DialogTitle>
      <DialogContent>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
          <TextField
            label="ชื่อกลุ่มลูกค้า"
            fullWidth
            value={name}
            onChange={(e) => setName(e.target.value)}
            helperText="กรอกชื่อกลุ่มลูกค้า เช่น กลุ่ม A001"
          />
          <TextField
            label="รายละเอียด"
            fullWidth
            value={detail}
            onChange={(e) => setDetail(e.target.value)}
            helperText="กรอกรายละเอียด"
            multiline
            rows={4}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>ยกเลิก</Button>
        <Button onClick={handleConfirm} variant="contained" color="success">
          {isEdit ? "บันทึกการแก้ไข" : "เพิ่มกลุ่มลูกค้า"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default GroupFormDialog;
